const API_URL_DEV = 'http://tracker.api.tribosoftware.com.br/api/';
const BASE_URL_DEV = 'http://tracker.tribosoftware.com.br/';
const CLIENT_ID_DEV = 'MsTracker';

const API_URL_HMG = 'http://tracker.api.tribosoftware.com.br/api/';
const BASE_URL_HMG = 'http://tracker.tribosoftware.com.br/';
const CLIENT_ID_HMG = 'MsTracker';

const API_URL_PRD = 'http://tracker.api.tribosoftware.com.br/api/';
const BASE_URL_PRD = 'http://tracker.tribosoftware.com.br/';
const CLIENT_ID_PRD = 'MsTracker';

let API_URL_DEF = '';
let BASE_URL_DEF = '';
let CLIENT_ID_DEF = '';

if (process.env.REACT_APP_STAGE === 'hmg') {

  API_URL_DEF = API_URL_HMG;
  BASE_URL_DEF = BASE_URL_HMG;
  CLIENT_ID_DEF = CLIENT_ID_HMG;

} else if (process.env.REACT_APP_STAGE === 'prd') {

  API_URL_DEF = API_URL_PRD;
  BASE_URL_DEF = BASE_URL_PRD;
  CLIENT_ID_DEF = CLIENT_ID_PRD;

} else {

  API_URL_DEF = API_URL_DEV;
  BASE_URL_DEF = BASE_URL_DEV;
  CLIENT_ID_DEF = CLIENT_ID_DEV;

}

export const API_URL = API_URL_DEF;
export const BASE_URL = BASE_URL_DEF;
export const CLIENT_ID = CLIENT_ID_DEF;



// WEBPACK FOOTER //
// ./src/constants.js